import { postPath, postIdFromPath, shareImage } from './postLinks';
import pages from './seoPages.json';
export function updatePageSeo(path, search = '', post) {
  const id = postIdFromPath(path) || (path === '/postbyid' ? new URLSearchParams(search).get('post_id') : null);
  const page = pages[id ? '/postbyid' : path] || { title: 'HappyTimes', description: 'Share a laugh on HappyTimes.' };
  const canonicalBase = document.querySelector('link[rel="canonical"]')?.href;
  const origin = process.env.REACT_APP_SITE_URL || (canonicalBase ? new URL(canonicalBase).origin : window.location.origin);
  const url = new URL(postPath(id) || path, origin);
  let description = page.description;
  if (post?.caption && post.caption !== '1') { try { description = decodeURIComponent(post.caption); } catch { description = post.caption; } }
  description = description.slice(0, 180);
  const title = post ? `${description.slice(0, 65)} — HappyTimes` : page.title;
  document.title = title;
  const meta = (key, value, property = false) => {
    const attr = property ? 'property' : 'name';
    let tag = document.head.querySelector(`meta[${attr}="${key}"]`);
    if (!tag) { tag = document.createElement('meta'); tag.setAttribute(attr, key); document.head.appendChild(tag); }
    tag.content = value;
  };
  meta('description', description);
  meta('robots', (pages[path] || postIdFromPath(path)) ? 'index,follow,max-image-preview:large' : 'noindex,follow');
  meta('og:title', title, true); meta('og:description', description, true); meta('og:url', url.href, true);
  const image = shareImage(post, new URL('/happytimes.png', origin).href);
  meta('og:type', 'website', true);
  document.querySelectorAll('meta[property^="og:video"]').forEach(tag => tag.remove());
  meta('og:image:secure_url', image, true); meta('og:image:alt', description, true);
  meta('og:image', image, true); meta('twitter:card', 'summary_large_image');
  meta('twitter:title', title); meta('twitter:description', description); meta('twitter:image', image);
  let canonical = document.head.querySelector('link[rel="canonical"]');
  if (!canonical) { canonical = document.createElement('link'); canonical.rel = 'canonical'; document.head.appendChild(canonical); }
  canonical.href = url.href;
}
